import React from 'react';
import { useNavigate } from 'react-router';

import StatusCell from '../../../components/Badge/StatusCell';
import ExitHistoryIcon from '../../../components/Icons/ExitHistoryIcon';
import LogReportIcon from '../../../components/Icons/LogReportIcon';
import RedExitIcon from '../../../components/Icons/RedExitIcon';
import ReUploadIcon from '../../../components/Icons/ReUploadIcon';
import UpdateEmployeeStatusIcon from '../../../components/Icons/UpdateEmployeeStatusIcon';
import UpdateProfileIcon from '../../../components/Icons/UpdateProfileIcon';
import UserProfileIcon from '../../../components/Icons/UserProfileIcon';
import ExitDispatcherModal from '../../../components/Modal/ModalActions/ExitDispatcherModal/ExitDispatcherModal';
import ExitHistoryModal from '../../../components/Modal/ModalActions/ExitHistoryModal/ExitHistoryModal';
import IndicateEmploymentStatusModal from '../../../components/Modal/ModalActions/IndicateEmploymentStatusModal/IndicateEmploymentStatusModal';
import LogComplaintModal from '../../../components/Modal/ModalActions/LogComplaintModal/LogComplaintModal';
import ReUploadInfoModal from '../../../components/Modal/ModalActions/ReUploadInfoModal/ReUploadInfoModal';
import UpdateDispatcherImageModal from '../../../components/Modal/ModalActions/UpdateDispatcherImageModal/UpdateDispatcherImageModal';
import Table from '../../../components/Table/Table';
import ActionRow from '../../../components/Table/TableAccessories/ActionRow';
import ActionRowWithModal from '../../../components/Table/TableAccessories/ActionRowWithModal';
import TableDateFormatter from '../../../components/Table/TableAccessories/TableDateFormatter';
import TableHasConflictTag from '../../../components/Table/TableAccessories/TableHasConflictTag';
import TableHasProfilePicture from '../../../components/Table/TableAccessories/TableHasProfilePicture';
import TablePhoneFormatter from '../../../components/Table/TableAccessories/TablePhoneFormatter';
import DriverListRowCell from '../../../components/Table/TableMobileRowCell/DriverListRowCell';
import { DRIVER_PERFORMANCE_REPORT } from '../../../routes/routeConstants';
import HiringConflict from './HiringConflict';
import ManageDriver from './ManageDriver';

const ActiveDriversList = () => {
  const navigate = useNavigate();

  const isConfirmed = (data: any) => data?.verificationStatus === 'Confirmed';
  const isRejected = (data: any) => data?.verificationStatus === 'Rejected';
  const isPending = (data: any) =>
    String(data?.verificationStatus ?? '').toLowerCase() === 'pending';
  const isImageUploaded = (data: any) => data?.imageUploaded === true;

  return (
    <>
      <Table
        tableFilterBoxFeatures={{
          showSearchBox: true,
          searchBoxPlaceholder: 'Search driver name...',
          rightAttr: [
            {
              type: 'regular',
              comp: <HiringConflict />,
            },
            {
              type: 'regular',
              comp: <ManageDriver />,
            },
          ],
        }}
        tableHeader={{
          'Start Date': 'startDate',
          'Driver Name': 'name',
          'Employment type': 'employmentType',
          'Image Status': 'imageUploaded',
          'Email Address': 'email',
          Phone: 'phoneNumber',
          'Validation Status': 'verificationStatus',
        }}
        tableDataSourceUrl='api/v1/company/drivers?status=Not-Exited'
        cellsCustomComp={{
          startDate: <TableDateFormatter dataKey='startDate' />,
          phoneNumber: <TablePhoneFormatter dataKey='phoneNumber' />,
          // name: <TableNameCapitalizeFormatter dataKey='name' />,
          imageUploaded: <TableHasProfilePicture dataKey='imageUploaded' />,
          employmentType: <StatusCell statusKey='employmentType' />,
          verificationStatus: <StatusCell statusKey='verificationStatus' />,
          name: <TableHasConflictTag dataKey='name' isRehiredKey='rehired' />,
        }}
        moreOptionsComponents={[
          <ActionRow
            key='Performance Management'
            label='Performance Management'
            width='257px'
            icon={<UserProfileIcon />}
            actionFn={(data) => {
              navigate(
                `/${DRIVER_PERFORMANCE_REPORT}/${encodeURIComponent(data?.nin || '-')}/${encodeURIComponent(data?.driverId || '-')}/${encodeURIComponent(data?.timeSpent || '-')}/${encodeURIComponent(data?.name || '-')}/${encodeURIComponent(data?.rating ?? 0)}/${encodeURIComponent(data?.profilePicture || 'image')}/${encodeURIComponent(data?.verificationStatus || '-')}`,
              );
            }}
            conditionalRenderFn={(data) => !isConfirmed(data)}
          />,
          <ActionRowWithModal
            key='Log Complaint'
            label='Log Complaint'
            width='257px'
            icon={<LogReportIcon />}
            modalCompFn={(data) => <LogComplaintModal data={data} />}
            conditionalRenderFn={(data) => !isRejected(data)}
          />,
          <ActionRowWithModal
            key='ReReupload Driver Details'
            label='Re-upload Driver Details'
            width='257px'
            icon={<ReUploadIcon />}
            modalCompFn={(data) => <ReUploadInfoModal data={data} />}
            conditionalRenderFn={(data) => !isRejected(data)}
          />,
          <ActionRowWithModal
            key='update-user-status'
            label='Update Employment Status'
            width='257px'
            icon={<UpdateEmployeeStatusIcon />}
            modalCompFn={(data) => (
              <IndicateEmploymentStatusModal data={data} />
            )}
            // conditionalRenderFn={(data) => !isConfirmed(data)}
            conditionalRenderFn={(data) => isRejected(data)}
          />,
          <ActionRowWithModal
            key='upload-driver-image'
            label='Upload Driver Image'
            width='257px'
            icon={<UpdateProfileIcon />}
            modalCompFn={(data) => <UpdateDispatcherImageModal data={data} />}
            // Always show for Pending; show for Confirmed only without an image (returning true hides the row)
            conditionalRenderFn={(data) => {
              if (isPending(data)) return false;
              return isImageUploaded(data) || isRejected(data);
            }}
          />,
          <ActionRowWithModal
            key='exit-driver'
            label='Exit Driver'
            width='257px'
            color='#D20832'
            icon={<RedExitIcon />}
            modalCompFn={(data) => <ExitDispatcherModal data={data} />}
          />,
          <ActionRowWithModal
            key='View Exit History'
            label='View Exit History'
            width='257px'
            icon={<ExitHistoryIcon />}
            modalCompFn={(data) => <ExitHistoryModal data={data} />}
            conditionalRenderFn={(data) => !data?.rehired}
          />,
        ]}
        mobileCellComp={<DriverListRowCell />}
        // showPaginationControl={false}
      />
    </>
  );
};

export default ActiveDriversList;
